<template>
	<div class="page">
		<div class="header">
			<div class="left">
				<img class="icon" src="@/img/homeIcon.png" @click="toHome" />
			</div>
			<div class="righ">
				<img class="icon" src="@/img/kf.png" @click="toKf" />
			</div>
		</div>

		<div class="body">
			<div class="item" v-for="(item, index) in list" :key="index" @click="toChoose(item, index)">
				<div class="left">
					<img :src="item.image" />
				</div>
				<div class="right">
					<p>{{ item.title }}</p>
					<span>{{ item.content }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			list: []
		};
	},
	created() {
		this.getBaseInfo()
	},
	computed: {},
	methods: {
		toKf() {
			this.$router.push({ path: `/ServiceOnline` })
		},
		toHome() {
			this.$router.push({
				path: '/Home'
			});
		},
		toChoose(item, index = 0) {
			if (index == 1) {
				this.$router.push({ path: '/Chooses', query: { id: 1 } })
			} else {
				this.$router.push({
					path: index == 0 ? '/chooseT' : '/choose',
					query: {
						title: item.title
					}
				});
			}
		},
		getBaseInfo() {
			this.$http({
				method: 'get',
				url: 'base_info'
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data.view || []
			})
		}
	},
};
</script>

<style lang="less" scoped>
.page {
	min-height: 100vh;
	// background: linear-gradient(180deg, #fb5aa5, #ed2e84, #ec3a88, #f8549b);
	background: linear-gradient(#e6c3a1, #f905e5);
	box-sizing: border-box;
	padding-top: 105px;

	.body {
		padding: 30px;
		display: flex;
		flex-direction: column;
		row-gap: 42px;
		align-items: center;

		.item {
			width: 100%;
			box-sizing: border-box;
			padding: 28px 30px;
			display: flex;
			align-items: center;
			background: #fefefe;
			color: #fb3799;
			border-radius: 30px;
			box-shadow: 5px 5px 0 #c53679;

			.left {
				img {
					width: 180px;
					height: 190px;
					border-radius: 30px;
					border: 4px solid #fff;
				}
			}

			.right {
				margin-left: 28px;

				p {
					font-size: 56px;
					font-weight: 700;
					margin-bottom: 10px;
				}

				span {
					font-size: 34px;
					font-weight: 600;
				}
			}
		}
	}

	.header {
		position: fixed;
		width: 100%;
		height: 105px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		// background: linear-gradient(30deg, #e62978, #d63f8c);
		background: linear-gradient(30deg, #e6c3a1, #ea96b1);
		top: 0;
		left: 0;
		box-sizing: border-box;
		padding: 0 30px;
		z-index: 1999;

		.icon {
			width: 62px;
			height: 62px;
		}
	}
}
</style>